import React from "react";
import "../styles/styles.css";

function FeaturesSection() {
  return (
    <section id="features" className="features-section">
      <div className="features-container">
        <div className="features-intro">
          <div className="badge">The Foundation</div>
          <h2>
            Built for the <br />
            <span className="italicize">thoughtful reader.</span>
          </h2>
          <p className="intro-subtitle">
            A quiet space where the app carries the <br />
            organizational burden.
          </p>
        </div>

        <div className="features-staggered-grid">
          {/* Feature 1 */}
          <div className="feature-card-premium">
            <span className="feature-number">01</span>
            <div className="feature-content">
              <h3>Capture at the speed of thought</h3>
              <p>
                Record voice transcripts or type quick reflections. Capture must
                be faster than thinking, so your insights never slip away.
              </p>
            </div>
            <div className="feature-accent-blob"></div>
          </div>

          {/* Feature 2 */}
          <div className="feature-card-premium">
            <span className="feature-number">02</span>
            <div className="feature-content">
              <h3>Automatic Organization</h3>
              <p>
                No more messy notebooks. Margin automatically organizes your
                notes into a beautiful, chronological timeline for every book on
                your shelf.
              </p>
            </div>
          </div>

          {/* Feature 3 */}
          <div className="feature-card-premium">
            <span className="feature-number">03</span>
            <div className="feature-content">
              <h3>Your Trusted Memory Vault</h3>
              <p>
                A permanent home for your learning. We prioritize long-term
                trust over short-term dopamine, quietly rewarding your growth.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default FeaturesSection;
